<template>
  <v-container>
    <MessagePopup :text="errorMessage" color="error"/>
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>
            <UserAddDialog
              @refresh="getData"
            />
        </v-toolbar>
      </template>
      <template v-slot:item.firstname="{ item }">
        {{ item.firstname }} {{ item.lastname }}
      </template>
      <template v-slot:item.roles="{ item }">
        <v-btn
          icon
          v-if="item.roles.includes('ROLE_ADMIN')"
          color="red"
          @click="updateItem(item['@id'] + '/grant', { roles: item.roles.filter(role => role !== 'ROLE_ADMIN') })"
        >
          <v-icon>mdi-account-supervisor</v-icon>
        </v-btn>
        <v-btn
          icon
          v-else
          @click="updateItem(item['@id'] + '/grant', { roles: item.roles.concat('ROLE_ADMIN') })"
        >
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>
      <template v-slot:item.actions="{ item }">
        <UserEditDialog
          :item="item"
          @refresh="getData"
        />
        <v-btn icon small color="error" @click="deleteItem(item)">
          <v-icon small>mdi-delete</v-icon>
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import MessagePopup from '@/components/MessagePopup.vue'
import UserAddDialog from '@/components/UserAddDialog.vue'
import UserEditDialog from '@/components/UserEditDialog.vue'

export default {
  data: () => ({
    headers: [
      { text: 'Id', value: 'id' },
      { text: 'Name', value: 'firstname' },
      { text: 'Email', value: 'email' },
      { text: 'Roles', value: 'roles' },
      { text: 'Actions', value: 'actions' }
    ],
    items: [],
    loading: true,
    errorMessage: ''
  }),
  components: {
    MessagePopup,
    UserAddDialog,
    UserEditDialog
  },
  watch: {
    options: {
      handler () {
        this.getData()
      },
      deep: true
    }
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData () {
      this.loading = true
      this.$http(
        this.$directory + '/users',
        {
          params: {
            pagination: false
          }
        }
      )
        .then(response => {
          this.items = response.data['hydra:member']
        })
        .catch(error => {
          if (!error.response) {
            this.errorMessage = error.message
          } else {
            this.errorMessage = error.response.data.error
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    updateItem (target, data) {
      this.$http.post(target,
        data
      )
        .finally(() => {
          this.getData()
        })
    },
    deleteItem (item) {
      if (confirm('Do you really want to remove ' + item.firstname + ' ' + item.lastname)) {
        this.$http.delete(item['@id'])
          .finally(() => {
            this.getData()
          })
      }
    }
  }
}
</script>
